import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';

import DeleteButton from '../components/DeleteButton';
import { deleteBarber } from '../../../actions/brand';
import confirmModal from '../../../../../common/confirmModal';

export default compose(
  connect(null, { deleteBarber }),
  withHandlers({
    onDelete: props => async () => {
      const confirmed = await confirmModal({
        type: 'danger',
        title: 'Delete barber',
        message: 'Are you sure you want to delete this barber?',
      });

      if (confirmed) {
        props
          .deleteBarber(props.brandId, props.brandBarberId)
          .then(() => props.router.push('/brand/barbers'));
      }
    },
  })
)(DeleteButton);
